import { apiInstance } from "shared/api";
import { GetProfileResponse, UpdateProfile } from "./types";

export const getProfile = (): Promise<GetProfileResponse> => {
  return apiInstance.get(`/v1/me`).then((response) => response.data);
};

export const updateProfile = (
  data: UpdateProfile,
): Promise<GetProfileResponse> => {
  return apiInstance.post(`/v1/me`, data).then((response) => response.data);
};
export const updateAutoPayoutStatus = (
  value: boolean,
): Promise<GetProfileResponse> => {
  return apiInstance
    .patch(`/v1/me/payout-settings`, { auto_payout_enabled: value })
    .then((response) => response.data);
};
